var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlowChart = function SvgFlowChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.1 20.55a3.15 3.15 0 1 1 3.02-4.05h5.08v-1.8H17V9.52L14.981 7.5H9.8v1.8H4.4V3.9h5.4v1.8h5.181L17.9 2.78l3.819 3.82L18.8 9.518V14.7h1.8v5.4h-5.4v-1.8h-5.08a3.15 3.15 0 0 1-3.02 2.25m0-4.5a1.35 1.35 0 1 0 .001 2.702 1.35 1.35 0 0 0-.001-2.701Zm11.7.45H17v1.8h1.8zm-.9-11.172-1.273 1.273L17.9 7.873l1.273-1.272zM8 5.701H6.2v1.8H8z"
  })));
};
export default SvgFlowChart;